import controller from './family-plan-member-info.controller';

export default {
  bindings: {
    type: '<'
  },
  controller ,
  template: require('./family-plan-member-info.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-info/family-plan-member-info.component.ts